"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class CustomField extends Parse.Object {
    constructor(attributes) {
        super('CustomField', attributes);
    }
    set retailer(value) {
        this.set('retailer', value);
    }
    get retailer() {
        return this.get('retailer');
    }
    set label(value) {
        this.set('label', value);
    }
    get label() {
        return this.get('label');
    }
    set resource(value) {
        this.set('resource', value);
    }
    get resource() {
        return this.get('resource');
    }
    set type(value) {
        this.set('type', value);
    }
    get type() {
        return this.get('type');
    }
    set required(value) {
        this.set('required', value);
    }
    get required() {
        return this.get('required');
    }
    set readOnly(value) {
        this.set('readOnly', value);
    }
    get readOnly() {
        return this.get('readOnly');
    }
    /**
     * Defines the order in the screen when the field is showed
     */
    set order(value) {
        this.set('order', value);
    }
    get order() {
        return this.get('order');
    }
    /**
     * Defines the order in the screen when the field is showed
     */
    set options(value) {
        this.set('options', value);
    }
    get options() {
        return this.get('options');
    }
}
exports.CustomField = CustomField;
Parse.Object.registerSubclass('CustomField', CustomField);
//# sourceMappingURL=CustomField.js.map